import React, { useState, useEffect, useCallback } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { SYSTMENACCESS, PAGE_LIMIT } from "helpers/viewContent";
import { FORMAT_TEXT, DATE_FORMAT, DATE_FORMAT_TIME } from "helpers/common";
import ReactPagination from "components/shared/ReactPagination";
import { DELETE_ALERT } from "helpers/constantsMessage";
import { PRODUCT_IMG } from "utils/constant";
import ContentLoader_ from "helpers/ContentLoader_";
//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import { getList_, deleteData_, updateData_ } from "store/services/commonService";

const Listing = ({ dispatch, itemsCountPerPage, totalItemsCount, loader }) => {
  //pagination
  const [activePage, setActivePage] = useState(1);
  const [listing, setListing] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    try {
      let query = {
        url: "system_access/list",
        page: activePage,
        limit: PAGE_LIMIT,
        common: false,
        search_string: searchValue,
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader: false }));
      let res = await dispatch(getList_(query));
      setListing(res?.body?.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const handleSearchChange = (event) => {
    const inputValue = event.target.value;
    setSearchValue(inputValue);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData();
    }, 400);

    return () => clearTimeout(timer);
  }, [searchValue]);

  useEffect(() => {
    fetchData();
  }, [activePage]);

  //pagination
  const handlePageChange = (page) => {
    setActivePage(page);
    window.scrollTo(0, 0);
  };

  //delete
  const deleteUsers_ = async (id) => {
    try {
      await DELETE_ALERT().then(async (willDelete) => {
        if (willDelete) {
          try {
            let query = {
              url: "system_access/delete",
              id: id,
            };
            await dispatch(deleteData_(query)).then(() => {
              fetchData();
            });
          } catch (err) {
            console.log(err);
          }
        }
      });
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
    }
  };
  //update status
  const updateStatus_ = async (data) => {
    try {
      let query = {
        url: `system_access/update_status`,
        id: data?.id,
        status: data?.status === "1" ? "0" : "1",
      };
      await dispatch(updateData_(query));
      fetchData();
    } catch (err) {
      console.log(err);
    }
  };
  const clearSerchFilter = () => {
    setSearchValue("");
    fetchData();
  };

  return (
    <>
      <Helmet title={SYSTMENACCESS.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-account-multiple menu-icon"></i>
          </span>{" "}
          {SYSTMENACCESS.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.system_access}>{SYSTMENACCESS.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Listing
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                <div className="row">
                  <div className="col-md-4">Listing</div>
                  <div className="col-md-6">
                    <div class="add-items d-flex">
                      <input
                        className="form-control"
                        autoComplete="chrome-off"
                        name="searchUnique"
                        type="text"
                        placeholder="Search name/email"
                        value={searchValue}
                        onChange={handleSearchChange}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        id="add-task"
                        onClick={clearSerchFilter}
                      >
                        <i class="mdi mdi-close-circle"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <Link to={Path.system_access_add} title="Add">
                      <button type="button" class="btn btn-lg btn-gradient-primary">
                        {" "}
                        + Add
                      </button>
                    </Link>
                  </div>
                </div>
              </h4>
              <div class="table-responsive actionSticky">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th> Full Name </th>
                      <th> Email </th>
                      <th> Status </th>
                      <th> Created At </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  {isLoading ? (
                    <div className="loader-class">
                      <ContentLoader_ />
                    </div>
                  ) : (
                    <>
                      <tbody>
                        {listing.length > 0 &&
                          listing.map((list, i) => {
                            return (
                              <tr key={i}>
                                <td className="py-1">
                                  {list?.name ? FORMAT_TEXT(list?.name) : "N/A"}
                                </td>
                                <td>{list?.email ? FORMAT_TEXT(list?.email) : "N/A"} </td>
                                <td onClick={() => updateStatus_(list)}>
                                  <label
                                    style={{ cursor: "pointer" }}
                                    className={`badge badge-gradient-${list?.status == 1 ? "success" : "danger"
                                      }`}
                                  >
                                    {list?.status == 1 ? "Block" : "Unblock"}
                                  </label>
                                </td>
                                <td>
                                  {list?.created_at ? DATE_FORMAT_TIME(list?.created_at) : "N/A"}
                                </td>
                                <td>
                                  <Link to={`${Path.system_access_edit}/${list?.id}`}>
                                    <label
                                      class="btn btn-sm btn btn-gradient-warning"
                                      style={{ cursor: "pointer" }}
                                      title="Edit"
                                    >
                                      <i className="mdi mdi-grease-pencil"></i>
                                    </label>
                                  </Link>
                                  &nbsp;&nbsp;
                                  <Link to={`${Path.system_accessview}/${list?.id}`}>
                                    <label
                                      className="btn btn-sm btn btn-gradient-info"
                                      style={{ cursor: "pointer" }}
                                      title="View"
                                    >
                                      <i className="mdi mdi-eye"></i>
                                    </label>
                                  </Link>
                                  &nbsp;&nbsp;
                                  <label
                                    className="btn btn-sm btn btn-gradient-danger"
                                    style={{ cursor: "pointer" }}
                                    title="Delete"
                                    onClick={() => deleteUsers_(list?.id)}
                                  >
                                    <i className="mdi mdi-delete"></i>
                                  </label>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </>
                  )}
                </table>
              </div>
              {listing.length > 0 && (
                <div className="pagination-box-review">
                  <ReactPagination
                    activePage={activePage}
                    itemsCountPerPage={itemsCountPerPage}
                    totalItemsCount={totalItemsCount}
                    handlePageChange={handlePageChange}
                  />
                </div>
              )}
              {!isLoading && listing.length == 0 && (
                <div className="row">
                  <div className="col-md-6 pt-5">
                    <span>No data found...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    itemsCountPerPage: state.Common.itemsCountPerPage,
    totalItemsCount: state.Common.totalItemsCount,
    loader: state.Common.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
